import React from 'react';
import PropTypes from 'prop-types';
import DevicesAdjustedForPets from '../DevicesAdjustedForPets/DevicesAdjustedForPets.js';
import '../../components/Button/Button.js';
import '../../components/AppLogo/AppLogo.js';
import '../../components/Avatar/Avatar.js';
import '../../components/Input/Input.js';
import '../../components/Input/PasswordInput.js';
import '../../components/Icon/Icon.js';
import '../../components/Image/Image.js';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner.js';
import '../../components/Note/Note.js';
import '../../components/RadioButton/RadioButton.js';
import '../../components/RoundButton/RoundButton.js';
import '../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../components/Expandable/Expandable.js';
import '../../components/PopOver/PopOver.js';
import '../../components/Wizard/Wizard.js';
import '../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../components/ToggleButton/ToggleButton.js';
import '../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../components/Checkbox/Checkbox.js';
import '../../components/SelectionField/SelectionField.js';
import '../../components/Card/Card.js';
import '../../components/Badge/Badge.js';
import '../../components/SettingsItem/SettingsItem.js';
import '../../components/SortableList/SortableList.js';
import '../../components/Contacts/ContactItem.js';
import '../../components/TopElement/TopElement.js';
import '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'classnames';
import 'react-i18next';
import '../../services/apiEndpoint/apiEndpoint.js';
import '../../services/translation/translationUtils.module.scss.js';
import '../../i18n/i18n.js';
import '../../components/Flag/Flag.js';
import '../../services/appConstants/appConstants.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../services/logout/rest-default-client/restDefaultClient.js';
import '../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import '../../services/utilities/languageUtil.js';
import '../../services/useContactUs/ContactUs.gql.js';
import '../../services/storageHandler/StorageHandler.js';
import '../../services/abortablePromise/AbortablePromise.js';
import '../../services/abortablePoller/AbortablePoller.js';
import '../../services/abortablePoller/ResumablePoller.js';
import '../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../components/Carousel/ImageCarousel.module.scss.js';
import PetWeightComponent from './PetWeightComponent.js';
import IntrusionVolumeComponent from './IntrusionVolumeComponent.js';
import DevicesAutomaticallyAdjustedForPets from './DevicesAutomaticallyAdjustedForPets.js';
import PetType from './PetType.js';
import styles from './PetSettings.module.scss.js';

var PetSettings = function PetSettings(_ref) {
  var onPetTypeUpdated = _ref.onPetTypeUpdated,
    onPetWeightUpdated = _ref.onPetWeightUpdated,
    onPetWeightError = _ref.onPetWeightError,
    onIntrusionVolumeUpdated = _ref.onIntrusionVolumeUpdated,
    onDeviceAdjustedForPet = _ref.onDeviceAdjustedForPet,
    showWeight = _ref.showWeight,
    showPetSettings = _ref.showPetSettings,
    showIntrusionVolume = _ref.showIntrusionVolume,
    switchedFromNone = _ref.switchedFromNone,
    error = _ref.error,
    _ref$originalValues = _ref.originalValues,
    devicesAutomaticallyAdjustedForPets = _ref$originalValues.devicesAutomaticallyAdjustedForPets,
    originalPetWeight = _ref$originalValues.originalPetWeight,
    originalIntrusionVolume = _ref$originalValues.originalIntrusionVolume,
    originalPetType = _ref$originalValues.originalPetType,
    petTypes = _ref$originalValues.petTypes,
    devicesAdjustableForPets = _ref$originalValues.devicesAdjustableForPets,
    isCallingBackend = _ref.isCallingBackend;
  if (isCallingBackend) {
    return /*#__PURE__*/React.createElement(LoadingSpinner, {
      dataTestId: "loading-spinner-pet-settings",
      relative: true,
      isLoading: true,
      centered: true,
      size: "medium",
      className: styles.spinner
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, devicesAutomaticallyAdjustedForPets && devicesAutomaticallyAdjustedForPets.length > 0 && /*#__PURE__*/React.createElement(DevicesAutomaticallyAdjustedForPets, {
    devices: devicesAutomaticallyAdjustedForPets
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.nopadding
  }, /*#__PURE__*/React.createElement(PetType, {
    petTypes: petTypes,
    onChange: onPetTypeUpdated,
    currentPetType: originalPetType || 'NONE'
  })), error && /*#__PURE__*/React.createElement("div", {
    className: styles.error
  }, error), showPetSettings && /*#__PURE__*/React.createElement(React.Fragment, null, showWeight && /*#__PURE__*/React.createElement(PetWeightComponent, {
    onPetWeightUpdated: onPetWeightUpdated,
    onError: onPetWeightError,
    originalPetWeight: originalPetWeight
  }), showIntrusionVolume && /*#__PURE__*/React.createElement(IntrusionVolumeComponent, {
    onIntrusionVolumeUpdated: onIntrusionVolumeUpdated,
    toggled: switchedFromNone(),
    originalIntrusionVolume: originalIntrusionVolume
  }), /*#__PURE__*/React.createElement(DevicesAdjustedForPets, {
    toggleAll: switchedFromNone(),
    devices: devicesAdjustableForPets,
    onChange: onDeviceAdjustedForPet
  })));
};
PetSettings.propTypes = {
  onPetTypeUpdated: PropTypes.func.isRequired,
  onPetWeightUpdated: PropTypes.func.isRequired,
  onPetWeightError: PropTypes.func.isRequired,
  onIntrusionVolumeUpdated: PropTypes.func.isRequired,
  onDeviceAdjustedForPet: PropTypes.func.isRequired,
  showWeight: PropTypes.bool.isRequired,
  showPetSettings: PropTypes.bool.isRequired,
  showIntrusionVolume: PropTypes.bool.isRequired,
  switchedFromNone: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  originalValues: PropTypes.shape({
    devicesAutomaticallyAdjustedForPets: PropTypes.arrayOf(PropTypes.shape({
      deviceLabel: PropTypes.string,
      area: PropTypes.string
    })),
    originalPetWeight: PropTypes.string,
    originalIntrusionVolume: PropTypes.bool,
    originalPetType: PropTypes.string,
    petTypes: PropTypes.arrayOf(PropTypes.string),
    devicesAdjustableForPets: PropTypes.arrayOf(PropTypes.object)
  }).isRequired,
  isCallingBackend: PropTypes.bool.isRequired
};
PetSettings.defaultProps = {};

export { PetSettings as default };
